import classes from './AmountInput.module.css';

type AmountInputProps = {
  onChange?: (value: number) => void;
  value?: number | string;
};

const AmountInput = (props: AmountInputProps) => {
  const inputChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = +event.target.value;
    props.onChange?.(value);
  };

  return (
    <div className={classes.controlContainer}>
      <div className={classes.valueContainer}>
        <div className={classes.inputContainer}>
          <input type="number" min={1} onChange={inputChangeHandler} value={props.value} />
        </div>
      </div>
    </div>
  );
};

export default AmountInput;
